import { CONTEXT_NAMES } from '@adsk/alloy-helpers';

import {
  createDataStore,
  fetchWithUrlValidation,
} from '../helpers/createDataModificationStore';

export type AccountOffering = {
  offeringExternalKey: string;
  trialOfferingExtKey?: string;
  isTrial?: boolean;
};

export type AccountOfferingsResponse = {
  subscriberContextId?: string;
  results: AccountOffering[];
};

export const useAccountOfferingsStore = () =>
  createDataStore<AccountOfferingsResponse>({
    contextName: CONTEXT_NAMES.AccountOfferingsContext,
    fetchFunction: fetchWithUrlValidation<AccountOfferingsResponse>(
      CONTEXT_NAMES.AccountOfferingsContext,
    ),
  })();

export type AccountOfferingsStore = ReturnType<typeof useAccountOfferingsStore>;
